import { ChevronDown } from "lucide-react";
import { getThemeClass, getThemeComponentGroup } from "@/src_new/shared/lib/themeComponentClasses";

type AvatarButtonProps = {
  initials: string;
  menuOpen: boolean;
  onClick: () => void;
};

export function AvatarButton({ initials, menuOpen, onClick }: AvatarButtonProps) {
  const avatarClasses = getThemeComponentGroup("avatar");

  return (
    <button
      onClick={onClick}
      aria-haspopup="true"
      aria-expanded={menuOpen}
      className={`group inline-flex items-center gap-2 rounded-full border px-2 py-1 shadow-sm hover:bg-theme-surface hover:shadow-md transition-all duration-200 ${getThemeClass(avatarClasses.buttonBorderColor, "border-theme-border/70")} ${getThemeClass(avatarClasses.buttonBgColor, "bg-theme-surface/80")} ${getThemeClass(avatarClasses.buttonTextColor, "text-theme-text")}`}
    >
      <span
        className={`inline-flex h-8 w-8 items-center justify-center rounded-full text-xs font-bold tracking-wide transition-transform duration-200 group-hover:scale-105 ${getThemeClass(avatarClasses.badgeBgColor, "bg-theme-text")} ${getThemeClass(avatarClasses.badgeTextColor, "text-theme-text-inverse")}`}
      >
        {initials}
      </span>
      <ChevronDown
        className={`h-4 w-4 ${getThemeClass(avatarClasses.iconColor, "text-theme-text/70")} transition-transform duration-200 ${
          menuOpen ? "rotate-180" : "rotate-0"
        }`}
      />
    </button>
  );
}
